import { Injectable } from '@angular/core';
import { BaseService, httpOptions } from '@core/service/base.service';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class MatgrpService extends BaseService {

  constructor(http: HttpClient) {
    super(http);
  }

  private url = 'api/matgrp';

  getUrl(): string {
    return this.url;
  }

  sync() {
    const url = `${this.getUrl()}/sync`;
    return this.http.post<any>(url,null,httpOptions);
  }

  findByMatgrpCodeAndWerks(matgrpCode,werks) {
    const url = `${this.getUrl()}/find-by-matgrp-werks/`+matgrpCode+'/'+werks;
    return this.http.get<any>(url,httpOptions);
  }
}
